var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25845 18.3419H0.260864V4.57307C0.260864 2.83219 1.39801 1.37852 3.08614 0.959421C4.7772 0.540311 6.45947 1.29352 7.27423 2.83219L7.32699 2.93183L12.6669 14.5671L18.0537 2.82926C18.8684 1.29059 20.5507 0.537381 22.2418 0.956481C23.9328 1.37559 25.07 2.82926 25.07 4.57014V23.8752H21.0724V5.82159L15.0174 19.0248C14.5983 19.9421 13.6751 20.5342 12.6669 20.5342C11.6587 20.5342 10.7355 19.9421 10.3164 19.0248L4.25845 5.82452V18.3419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadiLogo);
export default __webpack_public_path__ + "static/media/padi-logo.b3a81f49906042df72e0ed45fb4c7ab6.svg";
export { ForwardRef as ReactComponent };